import {h} from 'preact';
import {Field} from 'formik';
import cx from 'classnames';
import invoke from 'lodash.invoke';

export function Checkbox ( {name, label, value, inputClassNames, ...props} ) {
    return (
        <Field name={name}>
            {( {field, form} ) => {
                const isChecked = field.value && field.value.includes( value );
                const checkboxClasses = cx( 'checkbox', {'checked': isChecked} );
                return (
                    <label className="font-normal">
                        <span className="wrap-check">
                        <input
                            type="checkbox"
                            name={name}
                            value={value}
                            checked={isChecked}
                            onChange={e => {
                                invoke( props, 'onChange', e.target.checked, value );

                                if ( !field.value ) {
                                    form.setFieldValue( name, [value] );
                                    return;
                                }

                                if ( isChecked ) {
                                    const nextValue = field.value.filter( x => x !== value );
                                    form.setFieldValue( name, nextValue );
                                    return;
                                }

                                const nextValue = field.value.concat( value );
                                form.setFieldValue( name, nextValue );
                            }}
                        />
                            <span className={`${inputClassNames} ${checkboxClasses}`}></span>
                        </span>
                        {label}

                    </label>
                );
            }}
        </Field>
    );
}